/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  LiquiditySubtractOptions,
  LiquiditySubtractResponses,
} from '../types/LiquiditySubtract'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Subtract liquidity from a pool
 * {@link /v1/liquidity/pool/:pool_id/remove}
 */
export function liquiditySubtract<ThrowOnError extends boolean = true>(
  options: Options<LiquiditySubtractOptions, ThrowOnError>,
): Unwrappable<RequestResult<LiquiditySubtractResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/liquidity/pool/{pool_id}/remove',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<LiquiditySubtractResponses, ThrowOnError>>,
  )
}
